import React, { useEffect, useState } from "react";
import { Drawer, Typography, Box, Skeleton } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../../api/api";
import { category_one, category_two, category_three } from "../../api/urls";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { SearchComp } from "../Navbar";
// import { SearchComp } from "../Navbar";

const RightDrawer = ({ open, onClose }) => {
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [thirdCategories, setThirdCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSubDrawer, setShowSubDrawer] = useState(false);
  const [showThirdDrawer, setShowThirdDrawer] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const query =
    location.pathname === "/b2b_store"
      ? "?biz=b2b"
      : location.pathname === "/global_store"
        ? "?store=global"
        : "";

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const res = await api.get(`${category_one}${query}`);
        setCategories(res.data);
        setShowSubDrawer(false);
        setShowThirdDrawer(false);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    };
    if (open) fetchCategories();
  }, [open, query]);

  const handleCategoryClick = async (id) => {
    try {
      setLoading(true);
      const res = await api.get(
        `${category_two}?category_first=${id}&${query}`,
      );
      setSubCategories(res.data);
      setShowSubDrawer(true);
      setShowThirdDrawer(false);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const handleSubCategoryClick = async (id) => {
    try {
      setLoading(true);
      const res = await api.get(
        `${category_three}?category_second=${id}&${query}`,
      );
      setThirdCategories(res.data);
      setShowThirdDrawer(true);
      setShowSubDrawer(false);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowSubDrawer(false);
    setShowThirdDrawer(false);
    onClose();
  };

  const renderCategoryList = (list, clickHandler) => (
    <Box display="flex" flexDirection="column" gap={2} mt={2}>
      {list && list.length > 0 ? (
        list?.map((item) => (
          <Box
            key={item.id}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            px={4}
            py={1}
            sx={{
              cursor: "pointer",
              borderBottom: "none",
              transition: "background 0.2s",
              "&:hover": { backgroundColor: "#f0f0f0" },
            }}
            onClick={() => clickHandler(item.id)}
          >
            <Typography>{item.printable_name}</Typography>
            <ChevronRight style={{ color: "#000" }} />
          </Box>
        ))
      ) : (
        <Box px={4} py={1} color={"#ACACAC"}>
          {" "}
          No Categories available{" "}
        </Box>
      )}
    </Box>
  );

  const renderCategorySkeleton = () => (
    <Box display="flex" flexDirection="column" gap={4} mt={2} px={4}>
      {[...Array(10)].map((_, idx) => (
        <Skeleton
          key={idx}
          variant="rectangular"
          height={20}
          sx={{ borderRadius: "8px" }}
        />
      ))}
    </Box>
  );

  return (
    
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      sx={{ "& .MuiDrawer-paper": { width: "80%", maxWidth: 400 } }}
    >
      <div className="mb-5">
        <div className=" sticky top-0 bg-white">
          <div className="right-drawer-search my-4">
          <SearchComp onClose={onClose} />
        </div>

        <div className="flex px-4 items-center gap-2 mb-5">
          {(showSubDrawer || showThirdDrawer) && (
            <div
              onClick={() => {
                if (showThirdDrawer) {
                  setShowThirdDrawer(false);
                  setShowSubDrawer(true);
                } else {
                  setShowSubDrawer(false);
                }
              }}
              className="cursor-pointer"
            >
              <ChevronLeft />
            </div>
          )}
          <h4 className="font-semibold">
            {!showSubDrawer && !showThirdDrawer
              ? "All Categories"
              : showSubDrawer
                ? "Second Categories"
                : "Third Categories"}
          </h4>
        </div>
        </div>

        {loading
          ? renderCategorySkeleton()
          : !showSubDrawer && !showThirdDrawer
            ? renderCategoryList(categories, handleCategoryClick)
            : showSubDrawer && !showThirdDrawer
              ? renderCategoryList(subCategories, handleSubCategoryClick)
              : showThirdDrawer &&
                renderCategoryList(thirdCategories, (id) => {
                  const selected = thirdCategories.find((t) => t.id === id);
                  navigate(`/products?third_category=${selected.id}`, {
                    state: {
                      catID: selected.id,
                      name: selected.printable_name,
                    },
                  });
                  handleClose();
                })}
      </div>
    </Drawer>
  );
};

export default RightDrawer;
